{
  "01 Infobip": {
    "width": 220,
    "height": 125,
    "alt": "01 Infobip",
    "url": "/img/partner-logos/01_Infobip_logo_primary_rgb_color.webp"
  },
  "0524 Spectrum Partner Program": {
    "width": 220,
    "height": 125,
    "alt": "0524 Spectrum Partner Program",
    "url": "/img/partner-logos/0524_Spectrum_Partner_Program_Vert_RGB.webp"
  },
  "1111 Systems": {
    "width": 220,
    "height": 125,
    "alt": "1111 Systems",
    "url": "/img/partner-logos/1111_Systems_Logo_Stack.webp"
  },
  "1936 Nitel Elite Partner": {
    "width": 220,
    "height": 125,
    "alt": "1936 Nitel Elite Partner",
    "url": "/img/partner-logos/1936_Nitel_ElitePartner_FullColor.webp"
  },
  "25 Year Logo Icon": {
    "width": 220,
    "height": 125,
    "alt": "25 Year Logo Icon",
    "url": "/img/partner-logos/25_Year_Logo_Icon.webp"
  },
  "8x8": {
    "width": 220,
    "height": 125,
    "alt": "8x8",
    "url": "/img/partner-logos/8x8_600x276Pixels_DkGrey_Transparent_1.webp"
  },
  "991secure": {
    "width": 444,
    "height": 250,
    "url": "/img/partner-logos/911secure.svg",
    "alt": "991secure"
  },
  "A Standard Logo": {
    "width": 220,
    "height": 70,
    "alt": "A Standard Logo",
    "url": "/img/partner-logos/A_STANDARD_LOGO_-_Color_6.webp"
  },
  "ACC": {
    "width": 220,
    "height": 120,
    "alt": "ACC",
    "url": "/img/partner-logos/ACC_copy.webp"
  },
  "Access One": {
    "width": 250,
    "height": 125,
    "alt": "Access One",
    "url": "/img/partner-logos/Access_One_Logo_2023.webp"
  },
  "ACO": {
    "width": 220,
    "height": 125,
    "alt": "ACO",
    "url": "/img/partner-logos/ACO-Logo.webp"
  },
  "ADP": {
    "width": 220,
    "height": 125,
    "alt": "ADP",
    "url": "/img/partner-logos/ADP-Navy-Blue-01.webp"
  },
  "af-ht lockup": {
    "width": 220,
    "height": 125,
    "alt": "af-ht lockup",
    "url": "/img/partner-logos/af-ht_lockup-full-color-RGB1.webp"
  },
  "AireSpring": {
    "width": 220,
    "height": 68,
    "alt": "AireSpring",
    "url": "/img/partner-logos/AireSpring_Logo_Registered-2016-220.webp"
  },
  "Appgate": {
    "width": 220,
    "height": 55,
    "alt": "Appgate",
    "url": "/img/partner-logos/Appgate_Logo.webp"
  },
  "apx": {
    "width": 220,
    "height": 58,
    "alt": "apx",
    "url": "/img/partner-logos/apx.webp"
  },
  "Arelion": {
    "width": 200,
    "height": 125,
    "alt": "Arelion",
    "url": "/img/partner-logos/Arelion_Lockup_Black_CMYK_4.webp"
  },
  "aruba": {
    "width": 960,
    "height": 320,
    "url": "/img/partner-logos/aruba-hpearubewebsitelogo.webp",
    "alt": "aruba"
  },
  "Arvig": {
    "width": 220,
    "height": 67,
    "alt": "Arvig",
    "url": "/img/partner-logos/Arvig.webp"
  },
  "Aryaka": {
    "width": 220,
    "height": 125,
    "alt": "Aryaka",
    "url": "/img/partner-logos/Aryaka_New_Logo_Teal.webp"
  },
  "Astound": {
    "width": 220,
    "height": 125,
    "alt": "Astound",
    "url": "/img/partner-logos/Astound.webp"
  },
  "AT&T": {
    "width": 220,
    "height": 123,
    "alt": "AT&T",
    "url": "/img/partner-logos/att_biz_hz_alt_4cp_pos.webp"
  },
  "AudioCodes": {
    "width": 250,
    "height": 125,
    "alt": "AudioCodes",
    "url": "/img/partner-logos/audiocodes-logo-square.webp"
  },
  "aura": {
    "width": 444,
    "height": 250,
    "url": "/img/partner-logos/aura.svg",
    "alt": "aura"
  },
  "Avail": {
    "width": 220,
    "height": 120,
    "alt": "Avail",
    "url": "/img/partner-logos/Avail_Logo_no_background.webp"
  },
  "Avaya": {
    "width": 361,
    "height": 110,
    "alt": "Avaya",
    "url": "/img/partner-logos/avaya.svg"
  },
  "Azuga": {
    "width": 444,
    "height": 250,
    "alt": "Azuga",
    "url": "/img/partner-logos/azuga.svg"
  },
  "BCN": {
    "width": 220,
    "height": 125,
    "alt": "BCN",
    "url": "/img/partner-logos/bcn.webp"
  },
  "BetterCall": {
    "width": 220,
    "height": 125,
    "alt": "BetterCall",
    "url": "/img/partner-logos/bettercall.webp"
  },
  "Bigleaf": {
    "width": 250,
    "height": 125,
    "alt": "Bigleaf",
    "url": "/img/partner-logos/bigleaf-logo-primary-4x.webp"
  },
  "Blue Mantis": {
    "width": 220,
    "height": 125,
    "alt": "Blue Mantis",
    "url": "/img/partner-logos/Blue_Mantis_Full_Color.webp"
  },
  "Blue Team Alpha": {
    "width": 220,
    "height": 125,
    "alt": "Blue Team Alpha",
    "url": "/img/partner-logos/Blue_Team_Alpha_-_Logo.webp"
  },
  "Blueline": {
    "width": 220,
    "height": 125,
    "alt": "Blueline",
    "url": "/img/partner-logos/Blueline.webp"
  },
  "BP": {
    "width": 220,
    "height": 20,
    "alt": "BP",
    "url": "/img/partner-logos/bp-logo-default.webp"
  },
  "BPT": {
    "width": 220,
    "height": 125,
    "alt": "BPT",
    "url": "/img/partner-logos/BPT-Logo-Horizontal-1.webp"
  },
  "Breezeline": {
    "width": 220,
    "height": 85,
    "alt": "Breezeline",
    "url": "/img/partner-logos/Breezeline_Logo_2022.webp"
  },
  "Brightfin": {
    "width": 220,
    "height": 125,
    "alt": "Brightfin",
    "url": "/img/partner-logos/Brightfin-Logo.webp"
  },
  "Broadvoice": {
    "width": 220,
    "height": 125,
    "alt": "Broadvoice",
    "url": "/img/partner-logos/Broadvoice_Logo_Color_220x125.webp"
  },
  "Bullseye Telecom": {
    "width": 220,
    "height": 125,
    "alt": "Bullseye Telecom",
    "url": "/img/partner-logos/Bullseye-Telecom.webp"
  },
  "Calero": {
    "width": 220,
    "height": 125,
    "alt": "Calero",
    "url": "/img/partner-logos/Calero_Logo_Gradient_CMYK.webp"
  },
  "CallMiner": {
    "width": 220,
    "height": 45,
    "alt": "CallMiner",
    "url": "/img/partner-logos/callminer-newlogoFC.webp"
  },
  "CallTower": {
    "width": 220,
    "height": 125,
    "alt": "CallTower",
    "url": "/img/partner-logos/CallTower-Horizontal-Logo-Green.webp"
  },
  "cato": {
    "width": 596,
    "height": 300,
    "url": "/img/partner-logos/cato-catowebsitelogo.webp",
    "alt": "cato"
  },
  "CATO": {
    "width": 220,
    "height": 91,
    "alt": "CATO",
    "url": "/img/partner-logos/CATO_LOGO_2019.webp"
  },
  "CB Technologies": {
    "width": 220,
    "height": 125,
    "alt": "CB Technologies",
    "url": "/img/partner-logos/CB_logo_color_rgb.webp"
  },
  "CBTS": {
    "width": 219,
    "height": 125,
    "alt": "CBTS",
    "url": "/img/partner-logos/cbts_logo_cmyk_-219X125.webp"
  },
  "CCI": {
    "width": 220,
    "height": 53,
    "alt": "CCI",
    "url": "/img/partner-logos/CCI_logo_June2015_4c_hr.webp"
  },
  "CenterSquare": {
    "width": 220,
    "height": 125,
    "alt": "CenterSquare",
    "url": "/img/partner-logos/centersquare_primary_logo_black.webp"
  },
  "Channel Exchange": {
    "width": 1932,
    "height": 502,
    "alt": "Channel Exchange",
    "url": "/img/partner-logos/channel-exchange.svg"
  },
  "Channel Partner Badge": {
    "width": 220,
    "height": 125,
    "alt": "Channel Partner Badge",
    "url": "/img/partner-logos/Channel_Partner_Badge_FINAL.webp"
  },
  "Cirion": {
    "width": 220,
    "height": 125,
    "alt": "Cirion",
    "url": "/img/partner-logos/Cirion-RGB_Positivo-230x40px-01.webp"
  },
  "CIS": {
    "width": 220,
    "height": 125,
    "alt": "CIS",
    "url": "/img/partner-logos/CIS.webp"
  },
  "Cisco": {
    "width": 220,
    "height": 125,
    "alt": "Cisco",
    "url": "/img/partner-logos/Cisco-Logo.webp"
  },
  "Claro Enterprise Solutions": {
    "width": 220,
    "height": 115,
    "alt": "Claro Enterprise Solutions",
    "url": "/img/partner-logos/Claro_Enterprise_Solutions_vertical.webp"
  },
  "Cloudflare": {
    "width": 220,
    "height": 125,
    "alt": "Cloudflare",
    "url": "/img/partner-logos/cloudflare.webp"
  },
  "CMC Networks": {
    "width": 220,
    "height": 125,
    "alt": "CMC Networks",
    "url": "/img/partner-logos/CMC-Networks.webp"
  },
  "CMI": {
    "width": 220,
    "height": 37,
    "alt": "CMI",
    "url": "/img/partner-logos/CMI_logo_set_colour.webp"
  },
  "CMS360": {
    "width": 220,
    "height": 76,
    "alt": "CMS360",
    "url": "/img/partner-logos/CMS360_Logo.png"
  },
  "Coeo Solutions": {
    "width": 220,
    "height": 72,
    "alt": "Coeo Solutions",
    "url": "/img/partner-logos/Coeo_Solutions.webp"
  },
  "Cologix": {
    "width": 220,
    "height": 69,
    "alt": "Cologix",
    "url": "/img/partner-logos/Cologix_Logo_NoTagline.webp"
  },
  "Colt": {
    "width": 220,
    "height": 86,
    "alt": "Colt",
    "url": "/img/partner-logos/Colt.webp"
  },
  "Comcast Business": {
    "width": 444,
    "height": 250,
    "alt": "Comcast Business",
    "url": "/img/partner-logos/comcast-business.svg"
  },
  "CommandLink": {
    "width": 220,
    "height": 125,
    "alt": "CommandLink",
    "url": "/img/partner-logos/CommandLink.webp"
  },
  "CommunityWFM": {
    "width": 444,
    "height": 250,
    "alt": "CommunityWFM",
    "url": "/img/partner-logos/CommunityWFM.svg"
  },
  "ConectUS Wireless": {
    "width": 3565,
    "height": 677,
    "alt": "ConectUS Wireless",
    "url": "/img/partner-logos/ConectUS-Wireless-Logo-2022.webp"
  },
  "Console Connect": {
    "width": 220,
    "height": 125,
    "alt": "Console Connect",
    "url": "/img/partner-logos/Console-Connect-Logo---Blue---Stacked.webp"
  },
  "Content Guru": {
    "width": 220,
    "height": 125,
    "alt": "Content Guru",
    "url": "/img/partner-logos/Content_Guru_Logo_EPS-Dark_Blue_No_Tag-use_this.webp"
  },
  "CoreBTS": {
    "width": 220,
    "height": 125,
    "alt": "CoreBTS",
    "url": "/img/partner-logos/CoreBTS_logo_pos_CMYK.webp"
  },
  "Coresite": {
    "width": 220,
    "height": 47,
    "alt": "Coresite",
    "url": "/img/partner-logos/Coresite.webp"
  },
  "Coro": {
    "width": 220,
    "height": 125,
    "alt": "Coro",
    "url": "/img/partner-logos/Coro.webp"
  },
  "Corvid Cyberdefense": {
    "width": 220,
    "height": 83,
    "alt": "Corvid Cyberdefense",
    "url": "/img/partner-logos/Corvid_cyberdefense_blue_trans.webp"
  },
  "COX Business": {
    "width": 220,
    "height": 125,
    "alt": "COX Business",
    "url": "/img/partner-logos/COX-business.webp"
  },
  "crowdstrike": {
    "width": 900,
    "height": 232,
    "url": "/img/partner-logos/crowdstrike-crowdstrikewebsitelogo.webp",
    "alt": "crowdstrike"
  },
  "CT Americas": {
    "width": 220,
    "height": 29,
    "alt": "CT Americas",
    "url": "/img/partner-logos/CT_Americas_500x75_Horizontal_White_BKG.webp"
  },
  "CWFM": {
    "width": 220,
    "height": 125,
    "alt": "CWFM",
    "url": "/img/partner-logos/cwfm-lightbg-horiz.webp"
  },
  "Data Canopy": {
    "width": 220,
    "height": 86,
    "alt": "Data Canopy",
    "url": "/img/partner-logos/DataCanopyLogo.webp"
  },
  "Databank": {
    "width": 220,
    "height": 54,
    "alt": "Databank",
    "url": "/img/partner-logos/DATABANK_logotype_FINAL_25_01_2018.webp"
  },
  "Dataprise": {
    "width": 200,
    "height": 125,
    "alt": "Dataprise",
    "url": "/img/partner-logos/Dataprise_Logo_FullColor_1.webp"
  },
  "Deft": {
    "width": 220,
    "height": 125,
    "alt": "Deft",
    "url": "/img/partner-logos/Deft-Logo.webp"
  },
  "Dialpad": {
    "width": 444,
    "height": 250,
    "alt": "Dialpad",
    "url": "/img/partner-logos/dialpad.svg"
  },
  "Digital Realty": {
    "width": 220,
    "height": 125,
    "alt": "Digital Realty",
    "url": "/img/partner-logos/Digital_Realty_TM_Brandmark_CMYK_Black1.webp"
  },
  "Dobson Fiber": {
    "width": 220,
    "height": 125,
    "alt": "Dobson Fiber",
    "url": "/img/partner-logos/Dobson-Fiber-Logo.webp"
  },
  "Drawbridge Partners": {
    "width": 218,
    "height": 41,
    "alt": "Drawbridge Partners",
    "url": "/img/partner-logos/logo-drawbridge-partners_220.webp"
  },
  "DTV": {
    "width": 220,
    "height": 125,
    "alt": "DTV",
    "url": "/img/partner-logos/dtv_forbiz_1cs_ozone_285c.webp"
  },
  "Dynascale": {
    "width": 220,
    "height": 125,
    "alt": "Dynascale",
    "url": "/img/partner-logos/dynascale3.webp"
  },
  "Edify": {
    "width": 220,
    "height": 125,
    "alt": "Edify",
    "url": "/img/partner-logos/Edify.webp"
  },
  "Effectual": {
    "width": 220,
    "height": 125,
    "alt": "Effectual",
    "url": "/img/partner-logos/Effectual.webp"
  },
  "Effortless": {
    "width": 220,
    "height": 29,
    "alt": "Effortless",
    "url": "/img/partner-logos/Effortless-Logo-Yellow1.webp"
  },
  "Epic IO": {
    "width": 444,
    "height": 250,
    "alt": "Epic IO",
    "url": "/img/partner-logos/epic-io.svg"
  },
  "Equinix": {
    "width": 220,
    "height": 106,
    "alt": "Equinix",
    "url": "/img/partner-logos/Equinix.webp"
  },
  "eSentire": {
    "width": 444,
    "height": 250,
    "alt": "eSentire",
    "url": "/img/partner-logos/esentire.svg"
  },
  "Evolve IP": {
    "width": 220,
    "height": 125,
    "alt": "Evolve IP",
    "url": "/img/partner-logos/Evolve-IP.webp"
  },
  "EVS": {
    "width": 220,
    "height": 51,
    "alt": "EVS",
    "url": "/img/partner-logos/EVS-LogoTagline-RGB-GRADIENT-.webp"
  },
  "EXP": {
    "width": 220,
    "height": 43,
    "alt": "EXP",
    "url": "/img/partner-logos/EXP-LOGO-RGB_large.webp"
  },
  "Expedient": {
    "width": 220,
    "height": 125,
    "alt": "Expedient",
    "url": "/img/partner-logos/expedient.webp"
  },
  "Fatbeam Fiber": {
    "width": 220,
    "height": 125,
    "alt": "Fatbeam Fiber",
    "url": "/img/partner-logos/updated_blue_Fatbeam_Fiber_Final_logo-0133_copy.webp"
  },
  "FC": {
    "width": 220,
    "height": 46,
    "alt": "FC",
    "url": "/img/partner-logos/FC_Logo.webp"
  },
  "FiberLight": {
    "width": 220,
    "height": 57,
    "alt": "FiberLight",
    "url": "/img/partner-logos/FiberLight-Full-Color-RGB-220.webp"
  },
  "First Orion": {
    "width": 220,
    "height": 125,
    "alt": "First Orion",
    "url": "/img/partner-logos/first_orion.webp"
  },
  "Five9": {
    "width": 444,
    "height": 250,
    "alt": "Five9",
    "url": "/img/partner-logos/five9.svg"
  },
  "FL": {
    "width": 220,
    "height": 50,
    "alt": "FL",
    "url": "/img/partner-logos/FL-logo-reg-mark-rgb.webp"
  },
  "Flexential": {
    "width": 220,
    "height": 54,
    "alt": "Flexential",
    "url": "/img/partner-logos/flexential-logo-web-blue.webp"
  },
  "Frontier": {
    "width": 444,
    "height": 250,
    "alt": "Frontier",
    "url": "/img/partner-logos/frontier.svg"
  },
  "FullColor": {
    "width": 220,
    "height": 86,
    "alt": "FullColor",
    "url": "/img/partner-logos/fullcolor_1.webp"
  },
  "Fusion Connect": {
    "width": 444,
    "height": 250,
    "alt": "Fusion Connect",
    "url": "/img/partner-logos/fusion-connect.svg"
  },
  "Genesys": {
    "width": 444,
    "height": 250,
    "alt": "Genesys",
    "url": "/img/partner-logos/genesys.svg"
  },
  "GG": {
    "width": 220,
    "height": 75,
    "alt": "GG",
    "url": "/img/partner-logos/GGLOGO_RGB.webp"
  },
  "Global IQ": {
    "width": 200,
    "height": 125,
    "alt": "Global IQ",
    "url": "/img/partner-logos/Global_IQ.webp"
  },
  "GoExceed": {
    "width": 220,
    "height": 125,
    "alt": "GoExceed",
    "url": "/img/partner-logos/GoExceed_Logo.webp"
  },
  "Google ChromeOS": {
    "width": 220,
    "height": 57,
    "alt": "Google ChromeOS",
    "url": "/img/partner-logos/Google_ChromeOS_Horizontal_Full_Colour_White_Background_RGB.webp"
  },
  "Granite": {
    "width": 444,
    "height": 250,
    "alt": "Granite",
    "url": "/img/partner-logos/granite.svg"
  },
  "GTT": {
    "width": 220,
    "height": 125,
    "alt": "GTT",
    "url": "/img/partner-logos/GTT_Logo_AW_Green_RGB.webp"
  },
  "Hiya": {
    "width": 220,
    "height": 125,
    "alt": "Hiya",
    "url": "/img/partner-logos/Hiya_Full_Color_Logo.webp"
  },
  "Hyperion": {
    "width": 220,
    "height": 125,
    "alt": "Hyperion",
    "url": "/img/partner-logos/Hyperion.webp"
  },
  "IBM": {
    "width": 232,
    "height": 92,
    "alt": "IBM",
    "url": "/img/partner-logos/IBM-logo.webp"
  },
  "II": {
    "width": 444,
    "height": 250,
    "alt": "II",
    "url": "/img/partner-logos/ii.svg"
  },
  "IM Corp": {
    "width": 220,
    "height": 96,
    "alt": "IM Corp",
    "url": "/img/partner-logos/IM_Corp_Logo_Stacked_RGB.webp"
  },
  "iNET Communications": {
    "width": 220,
    "height": 67,
    "alt": "iNET Communications",
    "url": "/img/partner-logos/iNET-communications.webp"
  },
  "InflowCX": {
    "width": 220,
    "height": 125,
    "alt": "InflowCX",
    "url": "/img/partner-logos/InflowCX_Full_Color.webp"
  },
  "ini": {
    "width": 2000,
    "height": 2198,
    "url": "/img/partner-logos/ini-ini.webp",
    "alt": "ini"
  },
  "Intelepeer": {
    "width": 220,
    "height": 44,
    "alt": "Intelepeer",
    "url": "/img/partner-logos/Intelepeer_Blue_Logo.webp"
  },
  "intelisys": {
    "width": 1177,
    "height": 582,
    "url": "/img/partner-logos/intelisys.svg",
    "alt": "intelisys"
  },
  "Intelsat": {
    "width": 220,
    "height": 70,
    "alt": "Intelsat",
    "url": "/img/partner-logos/int_vsat_tm_4cp_grd.webp"
  },
  "Intrado": {
    "width": 220,
    "height": 79,
    "alt": "Intrado",
    "url": "/img/partner-logos/Intrado-color-tagline.webp"
  },
  "Inty": {
    "width": 220,
    "height": 125,
    "alt": "Inty",
    "url": "/img/partner-logos/Inty.webp"
  },
  "ir": {
    "width": 2000,
    "height": 2065,
    "url": "/img/partner-logos/ir-ir.webp",
    "alt": "ir"
  },
  "iTel": {
    "width": 141,
    "height": 125,
    "alt": "iTel",
    "url": "/img/partner-logos/itel_partner_2016_BLACK.webp"
  },
  "KORE": {
    "width": 220,
    "height": 69,
    "alt": "KORE",
    "url": "/img/partner-logos/KORE_Logo_RGB-2x.webp"
  },
  "Kore.ai": {
    "width": 200,
    "height": 125,
    "alt": "Kore.ai",
    "url": "/img/partner-logos/Kore.ai_Logo_Black_1.webp"
  },
  "Lightpath": {
    "width": 220,
    "height": 125,
    "alt": "Lightpath",
    "url": "/img/partner-logos/Lightpath_logo_blk.webp"
  },
  "LINGO": {
    "width": 220,
    "height": 73,
    "alt": "LINGO",
    "url": "/img/partner-logos/LINGO-LOGO.webp"
  },
  "LiquidWeb": {
    "width": 220,
    "height": 54,
    "alt": "LiquidWeb",
    "url": "/img/partner-logos/liquidweb-managed-web-hosting.webp"
  },
  "Logicworks": {
    "width": 220,
    "height": 125,
    "alt": "Logicworks",
    "url": "/img/partner-logos/Logicworks_Logo_220x125.webp"
  },
  "Logix": {
    "width": 220,
    "height": 62,
    "alt": "Logix",
    "url": "/img/partner-logos/Logix_Logo_x220.webp"
  },
  "LogMeIn": {
    "width": 220,
    "height": 109,
    "alt": "LogMeIn",
    "url": "/img/partner-logos/LogMeIn_Logo.webp"
  },
  "Logo Accent": {
    "width": 220,
    "height": 125,
    "alt": "Logo Accent",
    "url": "/img/partner-logos/Logo-Accent-L2x.webp"
  },
  "Logo BLK": {
    "width": 250,
    "height": 125,
    "alt": "Logo BLK",
    "url": "/img/partner-logos/Logo_BLK_3.webp"
  },
  "Logo with Tagline": {
    "width": 220,
    "height": 125,
    "alt": "Logo with Tagline",
    "url": "/img/partner-logos/Logo_-_Color_with_Tagline_Bottom_PNG.webp"
  },
  "LSN": {
    "width": 220,
    "height": 33,
    "alt": "LSN",
    "url": "/img/partner-logos/LSN_logo.webp"
  },
  "Lumen": {
    "width": 444,
    "height": 250,
    "alt": "Lumen",
    "url": "/img/partner-logos/lumen.svg"
  },
  "Magna5": {
    "width": 220,
    "height": 125,
    "alt": "Magna5",
    "url": "/img/partner-logos/Magna5-logo.webp"
  },
  "MassiveIT": {
    "width": 220,
    "height": 125,
    "alt": "MassiveIT",
    "url": "/img/partner-logos/MassiveIT.webp"
  },
  "Mediacom": {
    "width": 220,
    "height": 125,
    "alt": "Mediacom",
    "url": "/img/partner-logos/Mediacom.webp"
  },
  "Megaport": {
    "width": 125,
    "height": 125,
    "alt": "Megaport",
    "url": "/img/partner-logos/Megaport.webp"
  },
  "Meter": {
    "width": 444,
    "height": 250,
    "alt": "Meter",
    "url": "/img/partner-logos/meter.svg"
  },
  "MetTel": {
    "width": 220,
    "height": 74,
    "alt": "MetTel",
    "url": "/img/partner-logos/MetTel_Logo_RGB_color220.webp"
  },
  "Microsoft": {
    "width": 371,
    "height": 136,
    "alt": "Microsoft",
    "url": "/img/partner-logos/microsoft_logo.webp"
  },
  "Microsoft Teams": {
    "width": 220,
    "height": 122,
    "alt": "Microsoft Teams",
    "url": "/img/partner-logos/MicrosoftTeams-image_2.webp"
  },
  "Mitel": {
    "width": 220,
    "height": 90,
    "alt": "Mitel",
    "url": "/img/partner-logos/Mitel_Logo_Full_Color-Tagline.webp"
  },
  "Momentum": {
    "width": 220,
    "height": 125,
    "alt": "Momentum",
    "url": "/img/partner-logos/momentum-logo_1.webp"
  },
  "MORGAN BIRGE": {
    "width": 2000,
    "height": 525,
    "url": "/img/partner-logos/MORGAN-BIRGE-morganbirge.webp",
    "alt": "MORGAN BIRGE"
  },
  "N": {
    "width": 444,
    "height": 250,
    "alt": "N",
    "url": "/img/partner-logos/n.svg"
  },
  "N-Value": {
    "width": 220,
    "height": 125,
    "alt": "N-Value",
    "url": "/img/partner-logos/N-Value_Logo.webp"
  },
  "Natural Wireless": {
    "width": 220,
    "height": 81,
    "alt": "Natural Wireless",
    "url": "/img/partner-logos/Natural_Wireless_Logo_White.webp"
  },
  "NET DataCenter": {
    "width": 220,
    "height": 56,
    "alt": "NET DataCenter",
    "url": "/img/partner-logos/NET_DataCenterLogo-4C.webp"
  },
  "Net2Phone": {
    "width": 220,
    "height": 42,
    "alt": "Net2Phone",
    "url": "/img/partner-logos/Net2Phone-blue-red2.webp"
  },
  "Netrio": {
    "width": 220,
    "height": 87,
    "alt": "Netrio",
    "url": "/img/partner-logos/Netrio_Final_Tagline.webp"
  },
  "NetWolves": {
    "width": 220,
    "height": 86,
    "alt": "NetWolves",
    "url": "/img/partner-logos/NetWolves.webp"
  },
  "NEWSharpen": {
    "width": 250,
    "height": 125,
    "alt": "NEWSharpen",
    "url": "/img/partner-logos/NEWSharpen_Logo-Lockup_RGB_Black_4.18.24.webp"
  },
  "nextiva": {
    "width": 2000,
    "height": 1546,
    "url": "/img/partner-logos/nextiva-nextiva.webp",
    "alt": "nextiva"
  },
  "Nextiva": {
    "width": 220,
    "height": 125,
    "alt": "Nextiva",
    "url": "/img/partner-logos/nextiva_logo_rgb1.webp"
  },
  "Nexustek": {
    "width": 220,
    "height": 125,
    "alt": "Nexustek",
    "url": "/img/partner-logos/Nexustek_Logo_SoftSilver_ElectricBlue.webp"
  },
  "NHC": {
    "width": 220,
    "height": 61,
    "alt": "NHC",
    "url": "/img/partner-logos/new_NHC_logo_Light_Backgrounds.v1.webp"
  },
  "NICE": {
    "width": 444,
    "height": 250,
    "alt": "NICE",
    "url": "/img/partner-logos/nice.svg"
  },
  "Nordsec": {
    "width": 220,
    "height": 125,
    "alt": "Nordsec",
    "url": "/img/partner-logos/nordsec-horizontal.webp"
  },
  "NTT": {
    "width": 220,
    "height": 125,
    "alt": "NTT",
    "url": "/img/partner-logos/NTT-Logo1.webp"
  },
  "NTT Stacked": {
    "width": 220,
    "height": 125,
    "alt": "NTT Stacked",
    "url": "/img/partner-logos/NTT_Stacked_RGB.webp"
  },
  "ObserveAI": {
    "width": 220,
    "height": 125,
    "alt": "ObserveAI",
    "url": "/img/partner-logos/ObserveAI.webp"
  },
  "One Source": {
    "width": 220,
    "height": 125,
    "alt": "One Source",
    "url": "/img/partner-logos/One_Source.webp"
  },
  "Ontinue": {
    "width": 220,
    "height": 125,
    "alt": "Ontinue",
    "url": "/img/partner-logos/ontinue-wordmark.webp"
  },
  "Ooma": {
    "width": 444,
    "height": 250,
    "alt": "Ooma",
    "url": "/img/partner-logos/ooma.svg"
  },
  "Opt Biz": {
    "width": 220,
    "height": 125,
    "alt": "Opt Biz",
    "url": "/img/partner-logos/Opt_Biz_Logo_Vert_POS_RGB.webp"
  },
  "OS Logo": {
    "width": 220,
    "height": 170,
    "alt": "OS Logo",
    "url": "/img/partner-logos/OS_Logo_Primary_BlackGreen_CMYK.webp"
  },
  "Outsource Consultants": {
    "width": 220,
    "height": 59,
    "alt": "Outsource Consultants",
    "url": "/img/partner-logos/outsource-consultants-logo-220w.webp"
  },
  "palo alto": {
    "width": 1124,
    "height": 402,
    "url": "/img/partner-logos/palo-alto-paloaltowebsitelogo.webp",
    "alt": "palo alto"
  },
  "Poly AI": {
    "width": 444,
    "height": 250,
    "url": "/img/partner-logos/poly-ai.svg",
    "alt": "Poly AI"
  },
  "LivePerson": {
    "width": 220,
    "height": 125,
    "url": "/img/partner-logos/LivePerson-logo.png",
    "alt": "LivePerson"
  },
  "Swampfox": {
    "width": 444,
    "height": 250,
    "url": "/img/partner-logos/swampfox.svg",
    "alt": "Swampfox"
  },
  "Panterra": {
    "width": 220,
    "height": 125,
    "alt": "Panterra",
    "url": "/img/partner-logos/Panterra.webp"
  },
  "PassPoint": {
    "width": 200,
    "height": 125,
    "alt": "PassPoint",
    "url": "/img/partner-logos/PassPoint_Logo.webp"
  },
  "PDI": {
    "width": 220,
    "height": 125,
    "alt": "PDI",
    "url": "/img/partner-logos/PDI_Logo.webp"
  },
  "PhySaaS": {
    "width": 220,
    "height": 125,
    "alt": "PhySaaS",
    "url": "/img/partner-logos/PhySaaS.webp"
  },
  "Pilot": {
    "width": 225,
    "height": 75,
    "alt": "Pilot",
    "url": "/img/partner-logos/Pilot-Logo.webp"
  },
  "Playvox": {
    "width": 220,
    "height": 125,
    "alt": "Playvox",
    "url": "/img/partner-logos/Playvox.webp"
  },
  "PS Lightwave": {
    "width": 220,
    "height": 38,
    "alt": "PS Lightwave",
    "url": "/img/partner-logos/PS_Lightwave.webp"
  },
  "PureTalk": {
    "width": 220,
    "height": 125,
    "alt": "PureTalk",
    "url": "/img/partner-logos/PureTalk.webp"
  },
  "Quest": {
    "width": 220,
    "height": 125,
    "alt": "Quest",
    "url": "/img/partner-logos/Quest-Logo.webp"
  },
  "Rackspace": {
    "width": 220,
    "height": 125,
    "alt": "Rackspace",
    "url": "/img/partner-logos/Rackspace_Technology_Logo_RGB_BLK4.webp"
  },
  "RAP": {
    "width": 220,
    "height": 125,
    "alt": "RAP",
    "url": "/img/partner-logos/rap-logo-full-color-rgb-288px144ppi.webp"
  },
  "Regal": {
    "width": 444,
    "height": 250,
    "alt": "Regal",
    "url": "/img/partner-logos/regal.svg"
  },
  "Replicant": {
    "width": 220,
    "height": 125,
    "alt": "Replicant",
    "url": "/img/partner-logos/Replicant_Black.webp"
  },
  "Retarus": {
    "width": 220,
    "height": 125,
    "alt": "Retarus",
    "url": "/img/partner-logos/Retarus_Logo.webp"
  },
  "RingCentral": {
    "width": 444,
    "height": 250,
    "alt": "RingCentral",
    "url": "/img/partner-logos/ringcentral.svg"
  },
  "Ringsquared": {
    "width": 220,
    "height": 125,
    "alt": "Ringsquared",
    "url": "/img/partner-logos/Ringsquared-h-logo.webp"
  },
  "SADA": {
    "width": 220,
    "height": 125,
    "alt": "SADA",
    "url": "/img/partner-logos/SADA-Black.webp"
  },
  "Sangoma": {
    "width": 220,
    "height": 125,
    "alt": "Sangoma",
    "url": "/img/partner-logos/sangoma-logo-web1.webp"
  },
  "scansource": {
    "width": 444,
    "height": 250,
    "url": "/img/partner-logos/scansource.svg",
    "alt": "scansource"
  },
  "SeCAP": {
    "width": 220,
    "height": 125,
    "alt": "SeCAP",
    "url": "/img/partner-logos/SeCAP_logo_.webp"
  },
  "Segra": {
    "width": 220,
    "height": 125,
    "alt": "Segra",
    "url": "/img/partner-logos/Segra_Logo_Blue_002.webp"
  },
  "Semtech": {
    "width": 220,
    "height": 125,
    "alt": "Semtech",
    "url": "/img/partner-logos/SEMTECH-R-326-SW_is_now_Semtech-Logo-F_Horizontal.webp"
  },
  "sentinel one": {
    "width": 936,
    "height": 300,
    "url": "/img/partner-logos/sentinel-one-sentinelonewebsitelogo.webp",
    "alt": "sentinel one"
  },
  "Signature Logo": {
    "width": 183,
    "height": 125,
    "alt": "Signature Logo",
    "url": "/img/partner-logos/SignatureLogoUpdate.webp"
  },
  "Sinch": {
    "width": 220,
    "height": 125,
    "alt": "Sinch",
    "url": "/img/partner-logos/Sinch_Logotype_Black_RGB-220x125.webp"
  },
  "SM": {
    "width": 220,
    "height": 41,
    "alt": "SM",
    "url": "/img/partner-logos/SM-Logo-Horizontal-2018.webp"
  },
  "Spectrotel": {
    "width": 220,
    "height": 125,
    "alt": "Spectrotel",
    "url": "/img/partner-logos/Spectrotel-Logo-225x125.webp"
  },
  "Spectrum Community Solutions": {
    "width": 220,
    "height": 125,
    "alt": "Spectrum Community Solutions",
    "url": "/img/partner-logos/Spectrum_Community_Solutions_TM_RGB.webp"
  },
  "SPL-C": {
    "width": 220,
    "height": 69,
    "alt": "SPL-C",
    "url": "/img/partner-logos/SPL-C_2C_Positive_sRGB.webp"
  },
  "Sprinklr": {
    "width": 220,
    "height": 125,
    "alt": "Sprinklr",
    "url": "/img/partner-logos/Sprinklr.webp"
  },
  "SS Logo": {
    "width": 220,
    "height": 64,
    "alt": "SS Logo",
    "url": "/img/partner-logos/SS_logo_grey-Horizontal.webp"
  },
  "Stratix": {
    "width": 220,
    "height": 125,
    "alt": "Stratix",
    "url": "/img/partner-logos/Stratix_Logo_Standard_RGB.webp"
  },
  "Success KPI": {
    "width": 220,
    "height": 125,
    "alt": "Success KPI",
    "url": "/img/partner-logos/SuccessKPI_2color_0D4DCE.webp"
  },
  "Switch": {
    "width": 220,
    "height": 107,
    "alt": "Switch",
    "url": "/img/partner-logos/Switch_Logo-black-220.webp"
  },
  "Tailwind": {
    "width": 220,
    "height": 125,
    "alt": "Tailwind",
    "url": "/img/partner-logos/Tailwind-Logo.webp"
  },
  "Talkdesk": {
    "width": 220,
    "height": 58,
    "alt": "Talkdesk",
    "url": "/img/partner-logos/talkdesk_logo_2021.webp"
  },
  "Tangoe": {
    "width": 220,
    "height": 68,
    "alt": "Tangoe",
    "url": "/img/partner-logos/Tangoe-Logo_Green.webp"
  },
  "Teksecute": {
    "width": 220,
    "height": 125,
    "alt": "Teksecute",
    "url": "/img/partner-logos/teksecute.webp"
  },
  "Telefonica USA": {
    "width": 220,
    "height": 125,
    "alt": "Telefonica USA",
    "url": "/img/partner-logos/Telefonica-USA-logo1.webp"
  },
  "Telespace": {
    "width": 220,
    "height": 125,
    "alt": "Telespace",
    "url": "/img/partner-logos/telespace_blue_cmyk.webp"
  },
  "Telesystem Trust": {
    "width": 220,
    "height": 125,
    "alt": "Telesystem Trust",
    "url": "/img/partner-logos/Telesystem_Trust.webp"
  },
  "Telstra International": {
    "width": 220,
    "height": 125,
    "alt": "Telstra International",
    "url": "/img/partner-logos/Telstra_International-logo_C_RGB.webp"
  },
  "Third Wave": {
    "width": 220,
    "height": 125,
    "alt": "Third Wave",
    "url": "/img/partner-logos/Third_Wave-ver2.webp"
  },
  "Thrive": {
    "width": 220,
    "height": 166,
    "alt": "Thrive",
    "url": "/img/partner-logos/Thrive_Logo_Vector.webp"
  },
  "TierPoint": {
    "width": 220,
    "height": 142,
    "alt": "TierPoint",
    "url": "/img/partner-logos/TierPoint_logo_vertical_Large-Web.webp"
  },
  "Titanium": {
    "width": 220,
    "height": 125,
    "alt": "Titanium",
    "url": "/img/partner-logos/Titanium_Logo_Prof.webp"
  },
  "Titanngn": {
    "width": 444,
    "height": 250,
    "alt": "Titanngn",
    "url": "/img/partner-logos/titanngn.svg"
  },
  "TN Intelligent Mobility": {
    "width": 220,
    "height": 51,
    "alt": "TN Intelligent Mobility",
    "url": "/img/partner-logos/TN_Intelligent_Mobility220.webp"
  },
  "Touchtone": {
    "width": 220,
    "height": 57,
    "alt": "Touchtone",
    "url": "/img/partner-logos/touchtone.webp"
  },
  "TPX": {
    "width": 220,
    "height": 125,
    "alt": "TPX",
    "url": "/img/partner-logos/TPX_logo.webp"
  },
  "Trustwave": {
    "width": 220,
    "height": 125,
    "alt": "Trustwave",
    "url": "/img/partner-logos/Trustwave_logo_Color.webp"
  },
  "ujet": {
    "width": 2000,
    "height": 619,
    "url": "/img/partner-logos/ujet-ujet.webp",
    "alt": "ujet"
  },
  "UJET": {
    "width": 738,
    "height": 228,
    "alt": "UJET",
    "url": "/img/partner-logos/ujet.cx_220.webp"
  },
  "Unisys": {
    "width": 220,
    "height": 125,
    "alt": "Unisys",
    "url": "/img/partner-logos/Unisys_Logo_Color_RGB.webp"
  },
  "UNITI": {
    "width": 220,
    "height": 83,
    "alt": "UNITI",
    "url": "/img/partner-logos/UNITI_50632_Fiber_Logo_RGB.webp"
  },
  "Untitled": {
    "width": 183,
    "height": 125,
    "alt": "Untitled",
    "url": "/img/partner-logos/Untitled-1.webp"
  },
  "Unwired": {
    "width": 220,
    "height": 70,
    "alt": "Unwired",
    "url": "/img/partner-logos/unwired-logo-blue_w_new_tagline_x220.webp"
  },
  "US Signal": {
    "width": 220,
    "height": 34,
    "alt": "US Signal",
    "url": "/img/partner-logos/US-Signal-logo.webp"
  },
  "VerifiNow": {
    "width": 200,
    "height": 125,
    "alt": "VerifiNow",
    "url": "/img/partner-logos/verifinow-logo.webp"
  },
  "Verizon Partner Network": {
    "width": 220,
    "height": 125,
    "alt": "Verizon Partner Network",
    "url": "/img/partner-logos/VerizonPartnerNetwork_GlowWordmark_RGB.webp"
  },
  "Vesuvitas": {
    "width": 220,
    "height": 125,
    "alt": "Vesuvitas",
    "url": "/img/partner-logos/vesuvitas.webp"
  },
  "Vigilant": {
    "width": 220,
    "height": 51,
    "alt": "Vigilant",
    "url": "/img/partner-logos/vigilant_horizontal_nb.webp"
  },
  "VMOX": {
    "width": 220,
    "height": 79,
    "alt": "VMOX",
    "url": "/img/partner-logos/VMOX_logo_color.webp"
  },
  "Volli": {
    "width": 220,
    "height": 125,
    "alt": "Volli",
    "url": "/img/partner-logos/Volli-Logo.webp"
  },
  "Vonage": {
    "width": 220,
    "height": 125,
    "alt": "Vonage",
    "url": "/img/partner-logos/VonagePOE_Primary.webp"
  },
  "Voyce": {
    "width": 220,
    "height": 125,
    "alt": "Voyce",
    "url": "/img/partner-logos/Voyce.webp"
  },
  "Wanaware": {
    "width": 444,
    "height": 250,
    "url": "/img/partner-logos/wanaware.svg",
    "alt": "Wanaware"
  },
  "WARNER TELECOMM": {
    "width": 220,
    "height": 125,
    "alt": "WARNER TELECOMM",
    "url": "/img/partner-logos/WARNER_TELECOMM.webp"
  },
  "WF": {
    "width": 220,
    "height": 125,
    "alt": "WF",
    "url": "/img/partner-logos/WFLOGO_2022_STACKED.webp"
  },
  "WinEnt": {
    "width": 220,
    "height": 78,
    "alt": "WinEnt",
    "url": "/img/partner-logos/WinEnt_Logo_Stacked_B.webp"
  },
  "WOW Partner": {
    "width": 220,
    "height": 36,
    "alt": "WOW Partner",
    "url": "/img/partner-logos/WOW_Partner_Logo_RGB_horz.webp"
  },
  "WW DP": {
    "width": 200,
    "height": 125,
    "alt": "WW DP",
    "url": "/img/partner-logos/WW_DPLogo_Versions_DarkTeal-fill.webp"
  },
  "Xcitium": {
    "width": 200,
    "height": 125,
    "alt": "Xcitium",
    "url": "/img/partner-logos/Xcitium_Logo_Sized.webp"
  },
  "Yoursix": {
    "width": 220,
    "height": 125,
    "alt": "Yoursix",
    "url": "/img/partner-logos/Yoursix-logo.webp"
  },
  "Zayo": {
    "width": 201,
    "height": 65,
    "alt": "Zayo",
    "url": "/img/partner-logos/zayo-NEW-Aug-2020-logo-orange.webp"
  },
  "Zenlayer": {
    "width": 220,
    "height": 59,
    "alt": "Zenlayer",
    "url": "/img/partner-logos/ZenlayerLogo_blue_horizontal.webp"
  },
  "ZeroOutages": {
    "width": 200,
    "height": 125,
    "alt": "ZeroOutages",
    "url": "/img/partner-logos/ZeroOutages-logo.webp"
  },
  "Ziply Fiber": {
    "width": 220,
    "height": 125,
    "alt": "Ziply Fiber",
    "url": "/img/partner-logos/Ziply-Fiber.webp"
  },
  "Zoom": {
    "width": 220,
    "height": 125,
    "alt": "Zoom",
    "url": "/img/partner-logos/Zoom-new.webp"
  }
}
